<div class="publicsetting" style="padding: 0rem 3rem;">
  <h2 class="content-block title animate__animated animate__fadeIn
">{{'workSystemSetting.DeductionRules.DelayRule'|translate}}</h2>
  <app-deduction-rules></app-deduction-rules>
  <dx-data-grid #grid class="dx-card wide-card" [dataSource]="customDataSource" [showBorders]="false"
    [focusedRowEnabled]="true" [focusedRowIndex]="0" [allowColumnResizing]="true" [columnAutoWidth]="true"
    [columnHidingEnabled]="true" [showColumnLines]="false" [rowAlternationEnabled]="true" [showRowLines]="false"
    [errorRowEnabled]="false" [showBorders]="false" [rtlEnabled]="currentLang=='ar'?true:false"
    (onRowUpdating)="updateRow($event)" (onInitNewRow)="onInitNewRow($event)" (onEditingStart)="onEditingStart()"
    (onEditorPreparing)="onEditorPreparing($event)">
    <dxo-editing mode="popup" [useIcons]="false" [allowAdding]="true" [allowDeleting]="true" [allowUpdating]="true"
      [texts]="button">
      <dxo-popup [title]="addpopup" [showTitle]="true" [hideOnOutsideClick]="true">
      </dxo-popup>
      <dxo-texts [addRow]="addrowfun('workSystemSetting.DeductionRules.DelayRule')"
        confirmDeleteMessage="{{'tableinfo.deletebutton'|translate}}">
      </dxo-texts>
    </dxo-editing>

<dxo-paging  [pageSize]="10"> </dxo-paging>    <dxo-pager [visible]="true" allowedPageSizes="true" displayMode="full" [showPageSizeSelector]="true"
      [showInfo]="false" [showNavigationButtons]="true">
    </dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxi-column dataField="nameAr" [width]="190" caption="{{'tableinfo.NameAr'|translate}}" [hidingPriority]="8">

      <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}">
      </dxi-validation-rule>
      <dxi-validation-rule type="stringLength" [max]="50"
        message="{{'errors.NameLength' |translate}}"></dxi-validation-rule>
      <!-- <dxi-validation-rule
            type="async"
            message="{{'errors.token'|translate}} !!" 
            [validationCallback]="validateAsync"
          >
          </dxi-validation-rule> -->
    </dxi-column>
    <dxi-column dataField="nameEn" caption="{{'tableinfo.NameEn'|translate}}" [hidingPriority]="6">
    </dxi-column>

    <dxi-column dataField="dateOfRegistration" dataType="date" [allowEditing]="false"
      caption="{{'tableinfo.dateOfRegistration'|translate}}"></dxi-column>

    <dxi-column dataField="durationType" caption="{{'workSystemSetting.DeductionRules.Timing' |translate}}">
      <dxo-lookup [dataSource]="durationType" valueExpr="code" displayExpr="name"></dxo-lookup>
      <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}">
      </dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="type" caption="{{'tableinfo.type' |translate}}">
      <dxo-lookup [dataSource]="typeDropDown" valueExpr="code" displayExpr="name"></dxo-lookup>
      <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}">
      </dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="value" caption="{{'workSystemSetting.DeductionRules.rulevalue' |translate}}"
      dataType="number" [visible]="false">
      <dxi-validation-rule type="range" [min]="0" message="{{'errors.min'|translate}}">
      </dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="fromRule" caption="{{'tableinfo.from'|translate}}" dataType="number" [visible]="false">
      <dxi-validation-rule type="range" [min]="0" message="{{'errors.min'|translate}}">
      </dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="toRule" caption="{{'tableinfo.to'|translate}}" dataType="number" [visible]="false"
      [setCellValue]="setCellValueFromField">
      <dxi-validation-rule type="range" [min]="fromvalue" message="{{'errors.greater'|translate}}">
      </dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="description"  caption="{{'tableinfo.description'|translate}}"></dxi-column>
    <dxi-column dataField="isActive" dataType="boolean" caption="{{'tableinfo.isActive'|translate}}">
    </dxi-column>

    <dxi-column type="buttons">
      <dxi-button name="edit" text="{{'tableinfo.editbutton'|translate}}"></dxi-button>
      <dxi-button name="delete" text="{{'tableinfo.removebutton'|translate}}"></dxi-button>
    </dxi-column>
    <dxo-remote-operations [groupPaging]="true">
    </dxo-remote-operations>
  </dx-data-grid>
</div>